export default {"src":"/_next/static/media/0x2aF1dF3AB0ab157e1E2Ad8F88A7D04fbea0c7dc6.0f35369d.svg","height":540,"width":540,"blurWidth":0,"blurHeight":0};